import { IFinancingInsight } from "../types/ownerDashboard.types";
import { isoDateToMaskedDisplay } from "./maskedDate";
import { FinancingFormValues } from "./validateFinancingForm";
import { resolveAmortizationSystem } from "./resolveAmortizationSystem";

export function createEmptyFinancingFormValues(
  kenloPropertyId = ""
): FinancingFormValues {
  return {
    kenloPropertyId,
    amortizationSystem: "price",
    paymentStartDateDisplay: "",
    monthlyInstallment: "",
    financedAmount: "",
    annualInterestRatePct: "",
    installmentCount: "",
  };
}

export function buildFinancingFormValuesFromInsight(
  insight: IFinancingInsight
): FinancingFormValues {
  const amortizationSystem = resolveAmortizationSystem(insight.amortization_system);

  return {
    kenloPropertyId: insight.kenlo_property_id,
    amortizationSystem,
    paymentStartDateDisplay: isoDateToMaskedDisplay(insight.payment_start_date),
    monthlyInstallment:
      amortizationSystem === "price" ? String(insight.monthly_installment) : "",
    financedAmount:
      insight.financed_amount != null ? String(insight.financed_amount) : "",
    annualInterestRatePct:
      insight.annual_interest_rate_pct != null
        ? String(insight.annual_interest_rate_pct)
        : "",
    installmentCount:
      insight.installment_count != null ? String(insight.installment_count) : "",
  };
}
